import { IOption } from "./interfaces/option";
import { IOptionValue } from "./interfaces/option-value";
import { ControlHelpers } from "../helpers/control.helpers";

export class Option implements IOption {

  constructor() {
    this.optionTypeId = 0;
  }

  optionId: number;
  optionTypeId: number;
  questionId: number;
  hasChildren: boolean;
  description: string;
  optionValues: IOptionValue[];
  index: number;
  isDeleted: boolean;

  prepare(): void {
    if (this.index < 1) {
      this.index = 1;
    }

    if (!this.isDeleted) {
      this.isDeleted = false;
    }

    if (!this.hasChildren) {
      this.hasChildren = false;
    }

    // if (!this.description) {
    //   this.description = 'N/A';
    // }

    for (let i = 0; i < this.optionValues.length; i++) {
      this.optionValues[i].index = i + 1;
      this.optionValues[i].optionId = this.optionId;
    }

    this.optionValues.forEach(ov => {
      ov.prepare();
    });
  }

  isValid(): boolean {
    const valid = this.optionTypeId > 0 && this.questionId > 0 && this.index > 0;
    var ovValid = true;

    this.optionValues.forEach(ov => {
      if (!ov.isValid()) {
        ovValid = false;
      }
    });

    return valid && ovValid;
  }
}
